<template >
  <div>
    <a-spin tip="Загрузка..." :spinning="spinning" :indicator="indicator">
      <div class="spin-content">
        <slot></slot>
      </div>
    </a-spin>
  </div>
</template>

<script>

export default {
  name: 'Loading',
  props: {
    spinning: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      indicator: <a-icon type="loading" style="font-size: 24px" spin />
    }
  }
};
</script>

<style scoped lang='scss'>
@import '../../css/var.scss';

.spin-content{
    border: 1px solid white;
    // border: 1px solid #91d5ff;
    // background-color: #e6f7ff;
    background-color: white;
    // padding: 30px;
  }
</style>
